import { create } from "zustand";

const SIDEBAR_OPEN_STORAGE_KEY = "mivo.sidebarOpen";

function readSidebarOpen(): boolean {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return true;
  }

  const stored = window.localStorage?.getItem(SIDEBAR_OPEN_STORAGE_KEY);
  if (stored === null || stored === undefined) {
    return true;
  }

  return stored === "true";
}

function persistSidebarOpen(open: boolean) {
  if (typeof window !== "undefined" && typeof window.localStorage !== "undefined") {
    window.localStorage?.setItem(SIDEBAR_OPEN_STORAGE_KEY, String(open));
  }
}

interface UiState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
}

/** Lightweight UI preferences (server auth stays in TanStack Query + cookie session). */
export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: readSidebarOpen(),
  toggleSidebar: () =>
    set((state) => {
      const sidebarOpen = !state.sidebarOpen;
      persistSidebarOpen(sidebarOpen);
      return { sidebarOpen };
    }),
  setSidebarOpen: (open) => {
    persistSidebarOpen(open);
    set({ sidebarOpen: open });
  },
}));
